/* =========================================================================
   HOLY SPIRIT — FIX RUBBER-BAND iOS (GLOBAL · toda la tienda)
   -------------------------------------------------------------------------
   Evita el rubber-band (elastic overscroll) blanco de iPhone Safari cuando
   el usuario esta en el top del documento (scrollTop = 0) y arrastra hacia
   abajo. Aplica en TODAS las plantillas: Home, colecciones, producto,
   search, carrito, paginas estaticas, cuenta, wishlist, etc.

   Reglas:
   - Solo bloquea cuando: es iOS, el documento esta en scrollTop <= 0 y el
     gesto va hacia abajo (pull-down). El scroll normal NO se ve afectado.
   - NO bloquea gestos que empiezan dentro de un overlay con scroll propio
     (cart drawer, mega menu, dialogos o cualquier contenedor scrollable),
     para no romper su desplazamiento interno.
   - No afecta el bottom navigation ni ningun diseno/estilo.

   Carga: global, una sola vez, desde snippets/hs-head.liquid.
   ========================================================================= */
(function () {
  var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
              (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (!isIOS) return;

  var startY = 0;
  var lockAllowed = true; // false si el gesto empieza en un overlay scrollable

  // Recorre los ancestros del punto tocado: ¿nace dentro de algo que hace
  // su propio scroll? Si es asi, no interferimos con ese overlay.
  function inScrollableOverlay(node) {
    for (var el = node; el && el !== document.body && el !== document.documentElement; el = el.parentElement) {
      if (el.matches && el.matches('theme-drawer, dialog, .cart-drawer, .header-menu, .menu-drawer, .mega-menu, .hs-mobile-nav, [aria-modal="true"]')) return true;
      var oy = getComputedStyle(el).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && el.scrollHeight > el.clientHeight + 1) return true;
    }
    return false;
  }

  document.addEventListener('touchstart', function (e) {
    if (!e.touches || !e.touches.length) return;
    startY = e.touches[0].clientY;
    lockAllowed = !inScrollableOverlay(e.target);
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!lockAllowed || !e.touches || !e.touches.length) return;
    var currentY = e.touches[0].clientY;
    var pullingDown = currentY > startY;
    var atTop = window.scrollY <= 0 || document.documentElement.scrollTop <= 0;
    if (atTop && pullingDown) {
      e.preventDefault();
    }
  }, { passive: false });
})();
